import { createAction, createApiAction } from '@saucelabs/sl-util-redux';

import * as api from './api';
import * as types from './types';

export const getColumns = createApiAction(types.GET, api.getColumns);
export const putColumns = createApiAction(types.PUT, api.putColumns);

export const toggleColumn = createAction(types.TOGGLE);
